
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/accounts/term",
      function () {
        return require("private-next-pages/accounts/term/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/accounts/term"])
      });
    }
  